// removed by extract-text-webpack-plugin
module.exports = {"slick-initialized":"slick-initialized","slick-slide":"slick-slide","slick-active":"slick-active","slick-slider":"slick-slider","slick-track":"slick-track"};


//////////////////
// WEBPACK FOOTER
// ./src/components/video-slideshow/slick.css
// module id = 587
// module chunks = 0 1